export default __webpack_public_path__ + "static/media/HM.a9157abc.svg";